import React, { useEffect } from 'react'

//components material mui
import { Grid } from '@mui/material';

//components
import SectionFields from './SectionFields';

//
import { MOBILE } from '../../config';

/**
 *
 * @param {{ deviceIs: "DESKTOP" | "MOBILE" | "TABLET" }} param0
 * @returns
 */
export const InformacionAdicional = ({ deviceIs = "DESKTOP", campos = [], credenciales = { customerId:"00000000-0000-0000-0000-000000000000" } }) => {

  return (
      <div>
         <Grid container spacing={2} style={{ flexDirection: 'column', flexWrap: 'nowrap', backgroundColor: 'transparent', margin: 0, padding: deviceIs === MOBILE ? '0px' :'14px', width: 'auto' }}>
            {
                campos.map(section =>
                (
                    <div style={{ marginBottom: 10 }} >
                        <SectionFields
                           deviceIs={deviceIs}
                            key={section.sectionId} 
                            SectionId={section.sectionId}
                            SectionName={section.sectionName}
                            ListFields={section.fieldList}
                            IdRelacionado={credenciales.customerId}
                            SubModuloId={"00000000-0000-0000-0000-000000000000"}
                            />
                    </div>
                ))
            }
        </Grid>
      </div>
  )
}
